import SEOPage from "./SEOPage";

export default function IVFSpecialistAmbala() {
  return (
    <SEOPage
      title="IVF Specialist in Ambala | Amaanat IVF Clinic"
      description="Consult experienced IVF Specialists in Ambala for fertility assessment, IVF treatment, IUI treatment and reproductive healthcare."
      canonical="https://amaanativf.com/ivf-specialist-in-ambala"
      heading="IVF Specialist in Ambala"
      focusKeyword="IVF Specialist in Ambala"
    />
  );
}